export default {
  path: '/purchasing',
  name: 'purchasing',
  component: () => import('@/layouts/BaseLayout'),
  redirect: '/purchasing/purchase-create',
  children: [
    {
      path: 'purchase-create',
      meta: { title: '采购开单', permission: 'purchase-create' },
      component: () => import('@/views/purchasing/purchaseCreate/index'),
    },
    {
      path: 'purchase-record',
      meta: { title: '采购记录', permission: 'purchase-record' },
      component: () => import('@/views/purchasing/purchaseRecord/index'),
    },
    {
      path: 'purchase-record_detail',
      meta: { title: '采购记录详情', permission: 'purchase-record_detail' },
      component: () => import('@/views/purchasing/purchaseRecordDetail/index'),
    },
    {
      path: 'purchase-return-create',
      meta: { title: '采购退货', permission: 'purchase-return-create' },
      component: () => import('@/views/purchasing/purchaseReturnCreate/index'),
    },
    {
      path: 'return-record',
      meta: { title: '退货记录', permission: 'return-record' },
      component: () => import('@/views/purchasing/returnRecord/index'),
    },
    {
      path: 'return-record_detail',
      meta: { title: '退货记录详情', permission: 'return-record_detail' },
      component: () => import('@/views/purchasing/returnRecordDetail/index'),
    },
  ],
}